var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-tree", {
    ref: "tree",
    staticClass: "super-search-downdrop-tree",
    attrs: {
      data: _vm.options,
      "show-checkbox": _vm.multipe,
      "expand-on-click-node": _vm.multipe,
      props: {
        label: "_name",
        children: "children",
      },
      "node-key": "_id",
      "highlight-current": "",
    },
    on: { "node-click": _vm.nodeClickHandler, "check-change": _vm.checkChange },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var node = ref.node
          var data = ref.data
          return _c("span", { staticClass: "custom-tree-node" }, [
            _c("span", { class: { "node-disabled": _vm.nodeDisabled(data) } }, [
              _vm._v(_vm._s(node.label)),
            ]),
          ])
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }